import { render, staticRenderFns } from "./OverviewHeaderAndFilters.vue?vue&type=template&id=3c054802&scoped=true"
import script from "./OverviewHeaderAndFilters.vue?vue&type=script&lang=js"
export * from "./OverviewHeaderAndFilters.vue?vue&type=script&lang=js"
import style0 from "./OverviewHeaderAndFilters.vue?vue&type=style&index=0&id=3c054802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c054802",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomIconSearch: require('/home/userapp/components/Atom/Icon/IconSearch.vue').default,MoleculeDatepicker: require('/home/userapp/components/Molecule/Datepicker.vue').default,AtomIcon: require('/home/userapp/components/Atom/Icon.vue').default,MoleculeButton: require('/home/userapp/components/Molecule/Button/Button.vue').default,MoleculeButtonSearchFilter: require('/home/userapp/components/Molecule/Button/ButtonSearchFilter.vue').default,AtomIconCalendar: require('/home/userapp/components/Atom/Icon/IconCalendar.vue').default,AtomIconAppFilter: require('/home/userapp/components/Atom/IconApp/IconAppFilter.vue').default,AtomIconX: require('/home/userapp/components/Atom/Icon/IconX.vue').default,MoleculeFacet: require('/home/userapp/components/Molecule/Facet.vue').default})
